import {
  FieldDataTransitionsContent,
  FieldDataTransitionsResponse,
} from "@/features/coreWebVitals/types";

/**
 * 日別フィールドデータグラフapiのレスポンスをフロント用に加工する関数
 * @param response 日別フィールドデータグラフapiのレスポンス
 * @param device desktop または mobile
 * @returns ApexCharts で使用するデータ
 */
export const processFieldDataTransitions = (
  response: FieldDataTransitionsResponse,
  device: "desktop" | "mobile"
): {
  fcp: FieldDataTransitionsContent;
  lcp: FieldDataTransitionsContent;
  cls: FieldDataTransitionsContent;
  fid: FieldDataTransitionsContent;
} => {
  const date: string[] = [];
  const fcpScore: number[] = [];
  const fcpGoodRate: number[] = [];
  const fcpNeedsImprovementRate: number[] = [];
  const fcpPoorRate: number[] = [];
  const lcpScore: number[] = [];
  const lcpGoodRate: number[] = [];
  const lcpNeedsImprovementRate: number[] = [];
  const lcpPoorRate: number[] = [];
  const clsScore: number[] = [];
  const clsGoodRate: number[] = [];
  const clsNeedsImprovementRate: number[] = [];
  const clsPoorRate: number[] = [];
  const fidScore: number[] = [];
  const fidGoodRate: number[] = [];
  const fidNeedsImprovementRate: number[] = [];
  const fidPoorRate: number[] = [];

  if (device === "desktop") {
    response.fieldDataTransitions.desktop.forEach(value => {
      date.push(value.date);
      fcpScore.push(value.fcp.fcpScore);
      fcpGoodRate.push(value.fcp.goodRate);
      fcpNeedsImprovementRate.push(value.fcp.needsImprovementRate);
      fcpPoorRate.push(value.fcp.poorRate);
      lcpScore.push(value.lcp.lcpScore);
      lcpGoodRate.push(value.lcp.goodRate);
      lcpNeedsImprovementRate.push(value.lcp.needsImprovementRate);
      lcpPoorRate.push(value.lcp.poorRate);
      clsScore.push(value.cls.clsScore);
      clsGoodRate.push(value.cls.goodRate);
      clsNeedsImprovementRate.push(value.cls.needsImprovementRate);
      clsPoorRate.push(value.cls.poorRate);
      fidScore.push(value.fid.fidScore);
      fidGoodRate.push(value.fid.goodRate);
      fidNeedsImprovementRate.push(value.fid.needsImprovementRate);
      fidPoorRate.push(value.fid.poorRate);
    });
    return {
      fcp: {
        date: date,
        score: fcpScore,
        goodRate: fcpGoodRate,
        needsImprovementRate: fcpNeedsImprovementRate,
        poorRate: fcpPoorRate,
      },
      lcp: {
        date: date,
        score: lcpScore,
        goodRate: lcpGoodRate,
        needsImprovementRate: lcpNeedsImprovementRate,
        poorRate: lcpPoorRate,
      },
      cls: {
        date: date,
        score: clsScore,
        goodRate: clsGoodRate,
        needsImprovementRate: clsNeedsImprovementRate,
        poorRate: clsPoorRate,
      },
      fid: {
        date: date,
        score: fidScore,
        goodRate: fidGoodRate,
        needsImprovementRate: fidNeedsImprovementRate,
        poorRate: fidPoorRate,
      },
    };
  }

  if (device === "mobile") {
    response.fieldDataTransitions.mobile.forEach(value => {
      date.push(value.date);
      fcpScore.push(value.fcp.fcpScore);
      fcpGoodRate.push(value.fcp.goodRate);
      fcpNeedsImprovementRate.push(value.fcp.needsImprovementRate);
      fcpPoorRate.push(value.fcp.poorRate);
      lcpScore.push(value.lcp.lcpScore);
      lcpGoodRate.push(value.lcp.goodRate);
      lcpNeedsImprovementRate.push(value.lcp.needsImprovementRate);
      lcpPoorRate.push(value.lcp.poorRate);
      clsScore.push(value.cls.clsScore);
      clsGoodRate.push(value.cls.goodRate);
      clsNeedsImprovementRate.push(value.cls.needsImprovementRate);
      clsPoorRate.push(value.cls.poorRate);
      fidScore.push(value.fid.fidScore);
      fidGoodRate.push(value.fid.goodRate);
      fidNeedsImprovementRate.push(value.fid.needsImprovementRate);
      fidPoorRate.push(value.fid.poorRate);
    });
    return {
      fcp: {
        date: date,
        score: fcpScore,
        goodRate: fcpGoodRate,
        needsImprovementRate: fcpNeedsImprovementRate,
        poorRate: fcpPoorRate,
      },
      lcp: {
        date: date,
        score: lcpScore,
        goodRate: lcpGoodRate,
        needsImprovementRate: lcpNeedsImprovementRate,
        poorRate: lcpPoorRate,
      },
      cls: {
        date: date,
        score: clsScore,
        goodRate: clsGoodRate,
        needsImprovementRate: clsNeedsImprovementRate,
        poorRate: clsPoorRate,
      },
      fid: {
        date: date,
        score: fidScore,
        goodRate: fidGoodRate,
        needsImprovementRate: fidNeedsImprovementRate,
        poorRate: fidPoorRate,
      },
    };
  }
  return {
    fcp: {
      date: date,
      score: fcpScore,
      goodRate: fcpGoodRate,
      needsImprovementRate: fcpNeedsImprovementRate,
      poorRate: fcpPoorRate,
    },
    lcp: {
      date: [],
      score: [],
      goodRate: [],
      needsImprovementRate: [],
      poorRate: [],
    },
    cls: {
      date: [],
      score: [],
      goodRate: [],
      needsImprovementRate: [],
      poorRate: [],
    },
    fid: {
      date: [],
      score: [],
      goodRate: [],
      needsImprovementRate: [],
      poorRate: [],
    },
  };
};
